<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.promotion") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>

          <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("wms.menu.promotion") }}</h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleDetail($index, row)"
                    class="btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-list"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showDetailModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input :label="$t('name')" v-model="md.name"> </base-input>

        <base-input :label="$t('description')" v-model="md.desc"> </base-input>
        <ul class="list-group list-group-flush" data-toggle="checklist">
          <li
            class="list-group-item px-0"
            v-for="item in promotion"
            :key="item.InventoryID"
          >
            <div
              class="checklist-item"
              :class="{
                'checklist-item-checked': item.done,
                [`checklist-item-${item.checkType}`]: item.checkType,
              }"
            >
              <div class="checklist-info">
                <h5 class="checklist-title mb-0">{{ getInventoryNameByID(item.InventoryID) }} </h5>
                <small>{{ item.ProductName }}</small>
              </div>
              <div>
                <badge rounded type="default">{{ item.Amount }}</badge>
                
              </div>
            </div>
          </li>
        </ul>
      </form>

      <template slot="footer">
        
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input :label="$t('name')" v-model="md.name"> </base-input>

        <base-input :label="$t('description')" v-model="md.desc"> </base-input>
        <ul class="list-group list-group-flush" data-toggle="checklist">
          <li
            class="list-group-item px-0"
            v-for="item in promotion"
            :key="item.InventoryID"
          >
            <div
              class="checklist-item"
              :class="{
                'checklist-item-checked': item.done,
                [`checklist-item-${item.checkType}`]: item.checkType,
              }"
            >
              <div class="checklist-info">
                <h5 class="checklist-title mb-0">{{ item.StorageName }}</h5>
                <small>{{ item.ProductName }}</small>
              </div>
              <div>
                 <badge rounded type="default">{{ item.Amount }}</badge> - 
                 <base-button
                    @click.native="handleDeletePromotion(item)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
              </div>
            </div>
          </li>
        </ul>

        <base-input
          :label="$t('search')"
          v-model="searchKeyword"
          v-on:input="searchInventory()"
        >
        </base-input>

        <!-- // Show Inventory -->
        <div class="overflow-auto" style="height:500;">
        <el-table :data="inventoryList" style="width: 100%">
          <el-table-column label="name">
            <template slot-scope="scope">
              {{ scope.row.StorageName }}-{{ scope.row.ProductName }}</template
            >
          </el-table-column>

          <el-table-column label="quantity" :width="100">
            <template slot-scope="scope">
              <base-input
                v-model="scope.row.Quantity"
                @change="addPromotion(scope.row)"
              >
              </base-input>
              
            </template>
          </el-table-column>
        </el-table>
        </div>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import error from "./error";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsPromotion/getData",
      inventoryList: "WmsInventory/getSearch",
      getInventoryName: "WmsInventory/getInventoryName",
    }),
    tableData: function () {
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m)=>{
      //     return m.EnterpriseID == "" + this.$route.query.id
      //   });
      // }

      return this.tableDataOrg;
    },
    tableColumns: function () {
      return [
        {
          prop: "Name",
          label: this.$t("wms.storage_name"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "Description",
          label: this.$t("wms.storage_desc"),
          minWidth: 100,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      showDetailModal:false,
      md: {
        id: 0,
        name: "",
        desc: "",
      },
      inventory: [],
      searchKeyword: "",
      promotion: [],
    };
  },
  mounted() {
    this.listData();
    this.listInventory();
  },
  methods: {
    ...mapActions({
      createData: "WmsPromotion/createData",
      deleteData: "WmsPromotion/deleteData",
      listData: "WmsPromotion/listData",
      listInventory: "WmsInventory/listData",
      search: "WmsInventory/SearchInventory",
    }),
    getInventoryNameByID(id){
       let n =  this.inventoryList.filter( d => d.ID === id)[0]
      return n.StorageName + " - " + n.ProductName

    },
    addPromotion(row) {

      let amount = parseInt(row.Quantity)

      if (isNaN(amount)){
        return
      }
      let f = this.promotion.filter(d=>d.InventoryID === row.ID)

      if (row.Quantity == "0" || row.Quantity == ""){

        if (f.length == 0) return 

        let index = this.promotion.indexOf(f[0])
        this.promotion.splice(index,1)

        return
      }

      if (f.length == 0){
        this.promotion.push({
          InventoryID: row.ID,
          Amount: parseInt(row.Quantity),
          ProductName: row.ProductName,
          StorageName: row.StorageName,
        });
      } else {
        let index = this.promotion.indexOf(f[0])
        this.promotion[index].Amount = row.Quantity
      }

    },
    searchInventory() {
      this.search(this.searchKeyword);
    },
    handleDeletePromotion(item){
      let index = this.promotion.indexOf(item)
      console.log(index)
      this.promotion.splice(index,1)

    },
    handleDetail(index,row){
      this.showDetailModal=true
      this.md.name = row.Name
      this.md.desc = row.Description
      this.promotion = row.Data

    },
    handleCreate(action) {
      this.showAddModal = true;
      this.md.id = 0;
      this.md.name = "";
      this.md.desc = "";
      this.md.x = "";
      this.md.y = "";
      this.promotion=[];
      this.search("")
      this.listInventory();
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.id = row.ID;
      this.md.name = row.Name;
      this.md.desc = row.LocationDesc;
      this.md.x = row.X;
      this.md.y = row.Y;
    },
    handleUpdate() {
      this.showAddModal = false;
      // Create

      this.createData({
        Name: this.md.name,
        Description: this.md.desc,
        Detail : this.promotion.map(o => ({InventoryID: o.InventoryID, Amount: o.Amount}))
      })
        .then((resp) => {
          this.listData();
          swal.fire({
            title: this.$t("create_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        })
        .catch((err) => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData({
              id: row.PickupProfileID,
            })
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

.modal-content {
  min-width: 80% !important;
}

div.el-table tbody td, div.el-table thead th {
    padding: 0.1;
}
</style>
